import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider } from "./i18n/I18nContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Structures from "./pages/Structures";
import Routers from "./pages/Routers";
import RouterDetail from "./pages/RouterDetail";
import Profiles from "./pages/Profiles";
import WifiUsers from "./pages/WifiUsers";
import Reservations from "./pages/Reservations";
import Sessions from "./pages/Sessions";
import CaptivePortal from "./pages/CaptivePortal";
import Reports from "./pages/Reports";
import Logs from "./pages/Logs";
import Integrations from "./pages/Integrations";
import ApiDocs from "./pages/ApiDocs";
import MikrotikConfigurator from "./pages/MikrotikConfigurator";
import FreeRadius from "./pages/FreeRadius";
import GuestPortal from "./pages/GuestPortal";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400">Caricamento...</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <I18nProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/guest/:structureId" element={<GuestPortal />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/structures" element={<Protected><Structures /></Protected>} />
              <Route path="/routers" element={<Protected><Routers /></Protected>} />
              <Route path="/routers/:id" element={<Protected><RouterDetail /></Protected>} />
              <Route path="/mikrotik-config" element={<Protected><MikrotikConfigurator /></Protected>} />
              <Route path="/freeradius" element={<Protected><FreeRadius /></Protected>} />
              <Route path="/profiles" element={<Protected><Profiles /></Protected>} />
              <Route path="/users" element={<Protected><WifiUsers /></Protected>} />
              <Route path="/reservations" element={<Protected><Reservations /></Protected>} />
              <Route path="/sessions" element={<Protected><Sessions /></Protected>} />
              <Route path="/portal" element={<Protected><CaptivePortal /></Protected>} />
              <Route path="/reports" element={<Protected><Reports /></Protected>} />
              <Route path="/integrations" element={<Protected><Integrations /></Protected>} />
              <Route path="/api-docs" element={<Protected><ApiDocs /></Protected>} />
              <Route path="/logs" element={<Protected><Logs /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </I18nProvider>
    </div>
  );
}

export default App;
